import { useState, useEffect, useRef } from 'react';
import dataStub  from '../utils/dataStub.json';

const convertCopy = (json) => {
  return json.reduce((obj, item) => {
    const { custom_fields } = item;
    const primaryLang = item['name'].toLowerCase();

    const otherLangs = Object.entries(custom_fields).reduce((langs, [lang, value]) => {
      if (lang !== 'Copy Name') {
        langs[lang] = value;
      }
      return langs;
    }, {});
    obj[primaryLang] = otherLangs;
    return obj;
  }, {});
};

const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

const getAdSizes = (fieldsArray) => {
  if (!Array.isArray(fieldsArray)) return [];
  return fieldsArray.filter((field) => /^\d{2,3}x\d{2,3}$/.test(field.name)).map((field) => field.name);
};

export const useDataFetching = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const largeDataSet = useRef([]);
  const [processedData, setProcessedData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const isLocalhost = window.location.hostname === 'localhost';
        let responseData;

        if (isLocalhost) {
          window.agd = dataStub;
          responseData = window.agd;
        } else {
          if (window.agd) {
            responseData = window.agd;
          } else {
            throw new Error('window.agd not available');
          }
        }

        largeDataSet.current = responseData;
        setData(responseData);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Process data only once when it changes
  useEffect(() => {
    if (data && !processedData) {
      // Create copies to avoid mutating original data
      const adDataCopy = [...(data.display?.tasks || [])];
      const videoDataCopy = [...(data.video?.tasks || [])];

      setProcessedData({
        adData: shuffleArray(adDataCopy),
        videoData: shuffleArray(videoDataCopy),
        copy: convertCopy(data.copy?.tasks || []),
        config: data.config?.tasks || [],
        adSizes: getAdSizes(data.display?.tasks?.[0]?.custom_fields || []),
      });
    }
  }, [data, processedData]);

  return {
    data: processedData,
    rawData: largeDataSet.current,
    loading,
    error,
    refetch: () => {
      setLoading(true);
      setError(null);
      // Re-trigger the effect
      window.location.reload();
    },
  };
};
